module.exports = __webpack_public_path__ + "static/sport/bgi-form.7610a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bgi-form.png
// module id = rSJ6
// module chunks = 0